"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
var _toConsumableArray2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _mockjs = _interopRequireDefault(require("mockjs"));
var _index = require("../../src/utils/index.js");
var _routes = require("./routes.js");
var routes = (0, _index.deepClone)([].concat((0, _toConsumableArray2.default)(_routes.constantRoutes), (0, _toConsumableArray2.default)(_routes.asyncRoutes)));
var roles = [{
  key: 'admin',
  name: 'admin',
  description: 'Super Administrator. Have access to view all pages.',
  routes: routes
}, {
  key: 'editor',
  name: 'editor',
  description: 'Normal Editor. Can see all pages except permission page',
  routes: routes.filter(function (i) {
    return i.path !== '/permission';
  }) // just a mock
}, {
  key: 'visitor',
  name: 'visitor',
  description: 'Just a visitor. Can only see the home page and the document page',
  routes: [{
    path: '',
    redirect: 'dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      meta: {
        title: 'dashboard',
        icon: 'dashboard'
      }
    }]
  }]
}];
var _default = exports.default = [
// mock get all routes form server
{
  url: '/vue-element-admin/routes',
  type: 'get',
  response: function response(_) {
    return {
      code: 20000,
      data: routes
    };
  }
},
// mock get all roles form server
{
  url: '/vue-element-admin/roles',
  type: 'get',
  response: function response(_) {
    return {
      code: 20000,
      data: roles
    };
  }
},
// add role
{
  url: '/vue-element-admin/role',
  type: 'post',
  response: {
    code: 20000,
    data: {
      key: _mockjs.default.mock('@integer(300, 5000)')
    }
  }
},
// update role
{
  url: '/vue-element-admin/role/[A-Za-z0-9]',
  type: 'put',
  response: {
    code: 20000,
    data: {
      status: 'success'
    }
  }
},
// delete role
{
  url: '/vue-element-admin/role/[A-Za-z0-9]',
  type: 'delete',
  response: {
    code: 20000,
    data: {
      status: 'success'
    }
  }
}];